import { EncryptStorage } from 'encrypt-storage';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAdd, faAngleRight, faArrowLeft, faArrowRight, faBarsStaggered, faClose, faEdit, faHeadphones, faTrash, faSort, faSortUp, faSortDown, faQrcode, faBuilding, faIdCard, faChartLine, faUsers, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

const key = 'KgHvaZ11DM8k66ZOvYwzuyqQ8cYM30Ch';

library.add(faEdit, faTrash, faAdd, faAngleRight, faBarsStaggered, faHeadphones, faArrowLeft, faArrowRight, faArrowLeft, faClose, faSort, faSortUp, faSortDown, faQrcode, faBuilding, faIdCard, faChartLine, faUsers, faEye, faEyeSlash)

export const encryptStorage = new EncryptStorage(key);